import { EntityModel } from '@/interfaces'
import {
  ALL_CURRENCYOVERRIDES_QUERY,
  CREATE_CURRENCYOVERRIDE_MUTATION,
  DELETE_CURRENCYOVERRIDE_MUTATION,
  FORCE_DELETE_CURRENCYOVERRIDE_MUTATION,
  SINGLE_CURRENCYOVERRIDE_QUERY,
  UPDATE_CURRENCYOVERRIDE_MUTATION,
} from './graphql'
import systemCurrencyEntity from '@/entities/systemCurrency/entity'

const travelPricingCurrencyOverrideModel: EntityModel = {
  name: 'currencyOverride',
  namePlural: 'currencyOverrides',
  uniqueName: 'travelPricingCurrencyOverride',
  uniqueNamePlural: 'travelPricingCurrencyOverrides',
  path: 'travel/pricing/currencyOverride',
  baseUrl: '/travel/pricing/currencyOverrides',
  translationPrefix: 'entities:travelPricingCurrencyOverride.',
  getDisplayName: (values: any) => {
    return 'TRAVEL CURENCY OVERRIDE'
  },
  gql: {
    getAll: ALL_CURRENCYOVERRIDES_QUERY,
    getSingle: SINGLE_CURRENCYOVERRIDE_QUERY,
    create: CREATE_CURRENCYOVERRIDE_MUTATION,
    update: UPDATE_CURRENCYOVERRIDE_MUTATION,
    delete: DELETE_CURRENCYOVERRIDE_MUTATION,
    forceDelete: FORCE_DELETE_CURRENCYOVERRIDE_MUTATION,
  },
  attributes: {
    enabled: {
      name: 'enabled',
      label: 'entities:travelPricingCurrencyOverride.attributes.enabled.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    currency: {
      name: 'currency',
      label: 'entities:travelPricingCurrencyOverride.attributes.currency.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return systemCurrencyEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    exchangeRate: {
      name: 'exchangeRate',
      label: 'entities:travelPricingCurrencyOverride.attributes.exchangeRate.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingCurrencyOverrideModel
